<template>
	<div class="vstack">
		<div class="hstack gap-3 justify-content-between align-items-center">
			<div class="vstack lh-sm">
				<h5>{{ title }}</h5>
				<div class="text-xs text-muted">{{ dateTitle }}</div>
			</div>
			<div class="dropstart flex-shrink-0">
				<button type="button" class="btn btn-xs btn-neutral rounded-pill" data-bs-toggle="dropdown" aria-expanded="false">
					<i class="bi bi-graph-up pe-1"></i>{{ statusSelected.title }}
				</button>
				<div class="dropdown-menu">
					<a href="javascript:void(0);" class="dropdown-item" :class="{ 'fw-bold': (status == 'all') }" @click="status = 'all'">
						Totales
					</a>
					<a href="javascript:void(0);" class="dropdown-item" v-for="(info, index) in $env.MODEL.CustomerUser.statuses" v-bind:key="index" :class="{ 'fw-bold': (status == index) }" @click="status = index">
						{{ info.title }}
					</a>
				</div>
			</div>
		</div>
		<div class="mx-n1">
			<Responsive class="w-full">
				<template #main="{ width }">
					<Chart :size="{ width, height: 300 }" :margin="{ left: 5, top: 15, right: 5, bottom: 5 }" :data="data" :axis="axis">
						<template #layers>
							<Grid strokeDasharray="1,0" :hideX="true" :hideY="true" />
							<Line v-show="status == 'all'" :dataKeys="['name', 'all' ]" :lineStyle="{ stroke: '#1b73e8', strokeWidth: 3 }" :dotStyle="{ fill: '#1b73e8', strokeWidth: 2 }" type="monotone" />
							<template v-for="(info, index) in $env.MODEL.CustomerUser.statuses" v-bind:key="index">
								<Line v-show="status == index" :dataKeys="['name', index ]" :lineStyle="{ stroke: '#1b73e8', strokeWidth: 3 }" :dotStyle="{ fill: '#1b73e8', strokeWidth: 2 }" type="monotone" />
							</template>
						</template>
						<template #widgets>
							<Tooltip color="#0f172a" :config="tooltipConfig" />
						</template>
					</Chart>
				</template>
			</Responsive>
		</div>
	</div>
</template>

<script>
	import { ref, computed, inject } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';
	import { Responsive, Chart, Grid, Line, Tooltip } from 'vue3-charts';
	import { formatBetween, getDateRange } from '@/composables/date';

	export default {
		components: { Responsive, Chart, Grid, Line, Tooltip },
		props: {
			title: String,
			filters: Object,
			totals: Object
		},
		setup(props) {
			const $env = inject('$env');
			const status = ref('all');
			const dateTitle = formatBetween(props.filters.start_date, props.filters.end_date);
			const dateArray = getDateRange(props.filters.start_date, props.filters.end_date);
			const data = computed(() => {
				let detail = [];

				_.forEach(dateArray, (index) => {
					let info = { name: index };

					_.forOwn(props.totals[index], (value, key) => {
						info[key] = value;
					});

					detail.push(info);
				});

				return detail;
			});

			const tooltipConfig = computed(() => {
				let detail = [];

				detail['name'] = { label: 'Fecha' };
				_.forEach($env.MODEL.CustomerUser.statuses, (info, index) => {
					detail[index] = { label: info.title };
				});
				detail['all'] = { label: 'Totales' };

				return detail;
			});

			const statusSelected = computed(() => {
				if(status.value in $env.MODEL.CustomerUser.statuses) return $env.MODEL.CustomerUser.statuses[status.value];
				else if(status.value == 'all') return { title: 'Totales' };
				else return { title: 'Sin seleccionar' };
			});

			const xAxisDivisor = computed(() => {
				let max = 8,
					length = dateArray.length;

				if(length <= max) return 1;
				else return Math.ceil(length / max);
			});

			const axis = ref({
				primary: {
					type: 'band',
					format: (val, index) => {
						return (index % xAxisDivisor.value === 0) ? moment(val).format('DD/MM') : null;
					}
				},
				secondary: {
					type: 'linear',
					ticks: 3,
					format: (val, index) => {
						return (index % 2 === 0) ? val : null;
					}
				}
			});

			return { status, dateTitle, dateArray, data, tooltipConfig, statusSelected, axis }
		}
	}
</script>